var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.astabs && _vm.activeBoNavigationNodes.length > 0
        ? _c(
            "ul",
            { staticClass: "bo-navigation" },
            _vm._l(_vm.sortedActiveBoNavigationNodes, function(node) {
              return _c(
                "li",
                {
                  key: node.idfwbonavigation,
                  staticClass: "navigation-item",
                  attrs: { idfwbonavigation: node.idfwbonavigation },
                  on: {
                    click: function($event) {
                      return _vm.closeOverlays()
                    }
                  }
                },
                [
                  _c(
                    "router-link",
                    {
                      class: [
                        "bonavigation-link",
                        {
                          active:
                            [
                              _vm.strIdfwbonavigation1,
                              _vm.strIdfwbonavigation2
                            ].indexOf(node.idfwbonavigation.toString()) > -1
                        }
                      ],
                      attrs: { to: _vm.initBoNavigation(node.idfwbonavigation) }
                    },
                    [
                      node.imageicon
                        ? _c("icon", { attrs: { name: node.imageicon } })
                        : _vm._e(),
                      _vm._v("\n          " + _vm._s(node.name) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.astabs && _vm.activeBoNavigationNodes.length > 0
        ? _c(
            "v-tabs",
            {
              class: _vm.showMoreTabsBtn ? "with_more_btn" : "",
              attrs: { centered: _vm.centered, "fixed-tabs": "" }
            },
            [
              _vm._l(_vm.sortedActiveBoNavigationNodes, function(tab, index) {
                return (index <= _vm.numberOfTabs - 1 &&
                  !_vm.mobileBigAndBelow) ||
                  (index >= 0 && _vm.mobileBigAndBelow)
                  ? _c(
                      "v-tab",
                      {
                        key: index,
                        class: [
                          "tab",
                          {
                            active:
                              [
                                _vm.strIdfwbonavigation1,
                                _vm.strIdfwbonavigation2
                              ].indexOf(tab.idfwbonavigation.toString()) > -1
                          },
                          {
                            tabLive: tab.idfwbonavigationtypes.includes(
                              "INPLAYPERSPORTTYPE"
                            )
                          }
                        ],
                        attrs: {
                          idfwbonavigation: tab.idfwbonavigation.toString()
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.goToBoNavigation(tab.idfwbonavigation)
                          }
                        }
                      },
                      [
                        tab.imageicon
                          ? _c("icon", { attrs: { name: tab.imageicon } })
                          : _vm._e(),
                        _vm._v(_vm._s(tab.name))
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.activeBoNavigationNodes.length > _vm.numberOfTabs &&
              !_vm.mobileBigAndBelow
                ? _c(
                    "v-menu",
                    {
                      staticClass: "v-tabs__div",
                      attrs: {
                        "offset-y": "",
                        "max-width": "320",
                        "min-width": "212",
                        left: true,
                        bottom: true,
                        origin: "center",
                        "content-class": "menu_top_arrow_right"
                      }
                    },
                    [
                      !_vm.mobileBigAndBelow
                        ? _c(
                            "a",
                            {
                              staticClass: "more_tabs",
                              class: _vm.moreButtonState,
                              attrs: { slot: "activator" },
                              slot: "activator"
                            },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.$t("More")))]),
                              _vm._v(" "),
                              _vm.moreButtonState
                                ? _c("v-icon", [_vm._v("expand_less")])
                                : _c("v-icon", [_vm._v("expand_more")])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        _vm._l(_vm.sortedActiveBoNavigationNodes, function(
                          tab,
                          index
                        ) {
                          return index > _vm.numberOfTabs - 1
                            ? _c(
                                "v-list-tile",
                                {
                                  key: index,
                                  class: [
                                    "tab-li",
                                    {
                                      active:
                                        [
                                          _vm.strIdfwbonavigation1,
                                          _vm.strIdfwbonavigation2
                                        ].indexOf(
                                          tab.idfwbonavigation.toString()
                                        ) > -1
                                    }
                                  ],
                                  attrs: {
                                    idfwbonavigation: tab.idfwbonavigation.toString()
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.goToBoNavigation(
                                        tab.idfwbonavigation
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "list_title" }, [
                                    _vm._v(_vm._s(tab.name))
                                  ]),
                                  _c("icon", {
                                    attrs: {
                                      name: "icon-tick",
                                      colorName: "blue"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow &&
      _vm.astabs &&
      _vm.activeBoNavigationNodes.length > 0
        ? _c(
            "a",
            {
              staticClass: "open_competition_dialog",
              on: {
                click: function($event) {
                  return _vm.openDialogCompetitionSelect()
                }
              }
            },
            [
              _c("icon", {
                attrs: { name: "icon-preferences", colorName: "white" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.astabs && _vm.activeBoNavigationNodes.length > 0
        ? _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-competition-select",
                fullscreen: false
              },
              model: {
                value: _vm.dialogCompetitionSelect,
                callback: function($$v) {
                  _vm.dialogCompetitionSelect = $$v
                },
                expression: "dialogCompetitionSelect"
              }
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "dialog_header",
                  class: _vm.dialogCompetitionSelect
                },
                [
                  _c("v-flex", { staticClass: "left", attrs: { xs6: "" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Dialog.SelectCompetition")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { staticClass: "right", attrs: { xs6: "" } }, [
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.closeDialogCompetitionSelect()
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("Dialog.btn.CLOSE")))])]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                _vm._l(_vm.sortedActiveBoNavigationNodes, function(tab) {
                  return _c(
                    "v-list-tile",
                    {
                      key: tab.id,
                      class: [
                        "tab-li",
                        {
                          active:
                            [
                              _vm.strIdfwbonavigation1,
                              _vm.strIdfwbonavigation2
                            ].indexOf(tab.idfwbonavigation.toString()) > -1
                        }
                      ],
                      attrs: {
                        idfwbonavigation: tab.idfwbonavigation.toString()
                      },
                      on: {
                        click: function($event) {
                          _vm.goToBoNavigation(tab.idfwbonavigation)
                          _vm.closeOverlays()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "list_title" }, [
                        _vm._v(_vm._s(tab.name))
                      ]),
                      _c("icon", {
                        attrs: { name: "icon-tick", colorName: "blue" }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeBoNavigationNodes.length === 0
        ? _c("div", { staticClass: "place-holder" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd5f375a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd5f375a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/boNavigation.vue
// module id = null
// module chunks = 